import { Link } from '@playbooks/ui/components/link';

const AuthFooter = () => {
	const year = new Date().getFullYear();

	// Render
	return (
		<footer className='space-y-1 text-center text-xs text-foreground-subtle'>
			<p>
				By continuing, you agree to our{' '}
				<Link variant='link' href='/terms' className='inline h-auto p-0 text-inherit underline'>
					Terms of Service
				</Link>{' '}
				and{' '}
				<Link variant='link' href='/privacy' className='inline h-auto p-0 text-inherit underline'>
					Privacy Policy
				</Link>
				.
			</p>
			<p>© {year} Playbooks</p>
		</footer>
	);
};

export { AuthFooter };
